import React from "react";

const Manufacture = () => {
  return (
    <>
      <div className="manufacture py-5">
        <div className="container py-lg-3">
          <div className="row">
            <div className="col-lg-12">
              <div className="manufacture-content text-center">
                <p className="text-uppercase manufacture-heading">
                  Choosing the Right Manufacturer
                </p>
                <p className="manufacture-subhead">Rumeno Farmotech</p>
                <p className="manufacture-para px-lg-5">
                  There are a few things to consider when choosing a producer of
                  animal feed supplements, Rumeno Farmotech places a high
                  priority on quality assurance. We put our products through a
                  comprehensive testing process to make sure they are safe,
                  effective, and meet industry requirements.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Manufacture;
